import React from 'react';
import { render } from 'react-dom';
import Immutable from 'seamless-immutable';
import EpicGamesNav from './EpicGamesNav';
import { addObserverCallback } from './utils/epicGamesNavObserver';
import 'console-shim';

const renderNav = () => {
    const config = window._epicGamesNavObserver.subject;
    const epicPropertyName = config.epicPropertyName;
    const epicPropertyClasses = config.epicPropertyClasses;
    const isLoggedIn = config.isLoggedIn;
    const links = Immutable(config.links);
    const hideLocale = config.hideLocale;
    const hideSearch = config.hideSearch;
    const hideSignIn = config.hideSignIn;
    const hideCallToAction = config.hideCallToAction;
    const callToAction = Immutable(config.callToAction);
    const localeOptions = Immutable(config.localeOptions);
    const logoLink = Immutable(config.logoLink);
    const accountLinks = Immutable(config.accountLinks);
    const downloadLink = Immutable(config.downloadLink);
    const displayName = config.displayName;
    const locale = config.locale;
    const messages = Immutable(config.messages);
    const properties = Immutable(config.properties);
    const onSearch = config.onSearch;
    const pcDownloadUrl = config.pcDownloadUrl;
    const macDownloadUrl = config.macDownloadUrl;

    render(
        <EpicGamesNav
            epicPropertyName={epicPropertyName}
            epicPropertyClasses={epicPropertyClasses}
            isLoggedIn={isLoggedIn}
            links={links}
            hideLocale={hideLocale}
            hideSearch={hideSearch}
            hideSignIn={hideSignIn}
            downloadLink={downloadLink}
            hideCallToAction={hideCallToAction}
            callToAction={callToAction}
            localeOptions={localeOptions}
            logoLink={logoLink}
            displayName={displayName}
            locale={locale}
            accountLinks={accountLinks}
            messages={messages}
            properties={properties}
            onSearch={onSearch}
            pcDownloadUrl={pcDownloadUrl}
            macDownloadUrl={macDownloadUrl}/>,

        document.getElementById('epicGamesNavigation')
    );
};

addObserverCallback(renderNav);
renderNav();



/** WEBPACK FOOTER **
 ** ./app/scripts/index.js
 **/